import { faTag } from '@fortawesome/pro-light-svg-icons';
import cuid from 'cuid';
import gql from 'graphql-tag';

const MetadataConcept = {
  searchFragment: gql`
        fragment searchMetadataConcept on MetadataTag {
          id
          name
          tagTitle
          tagDescription
          tagDisplayName
          tagType
          hierarchy
          createdAt
          updatedAt
          hasDerivedStandards
        }
      `,
  fullFragment: gql`
        fragment fullMetadataConcept on MetadataTag { 
        id
        name
        tagTitle
        tagDescription
        tagDisplayName
        tagType
        hierarchy
        certicaId
        origin
        createdAt
        updatedAt
        hasDerivedStandards
        }
    `,
  defaults: (id, data = {}) => {
    const tagId = id || cuid();
    const tagTitle = data.newLabel || null;

    return {
      client: {
        id: tagId,
        __typename: 'MetadataTag',
        tagType: 'PUBLIC_TAG',
        name: tagTitle || 'MetadataConcept',
        tagTitle,
        tagDescription: null,
        tagDisplayName: null,
        hasDerivedStandards: false,
        hierarchy: [],
        certicaId: null,
        origin: 'HUMAN',
        createdAt: (new Date()).toISOString(),
        updatedAt: (new Date()).toISOString(),
        assignedCount: 0
      },
      server: {
        id,
        tagTitle
      }
    };
  },
  icon: faTag,
  typename: 'MetadataConcept',
  openInApp: false,
  forms: {},
  inputs: {
    conceptTags: {
      input: 'select',
      name: 'metadataCerticaConcepts',
      label: 'Certica Concepts',
      isMulti: true,
      isAsync: true,
      isRelation: true,
      isMetadataService: true,
      type: 'MetadataConcept',
      tooltipText: 'Taxonomy tags to indicate the specific knowledge and skills that the content supports within a subject area for alignment or content categorization purposes.',
      tooltipFeaturesPowered: 'Alexandria standard recommendations.',
      query: 'searchMetadataConcepts',
      showDropdown: false,
      mapping: {
        label: 'tagTitle',
        value: 'id',
        type: 'tagType',
        path: 'hierarchy',
        hasDerivedStandards: 'hasDerivedStandards',
      }
    }
  },
};
export default MetadataConcept;
